// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../Core.Generator/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disclosures{margin-top:50px;padding:0 24px 1.5rem}.disclosures .block__body{font-size:14px}.disclosures .block__body .block__control_accordion{color:var(--core__footer-disclosure-label-color);cursor:pointer;font-weight:var(--core__footer-disclosure-label-weight);padding-bottom:1.5rem}.disclosures .block__body .block_rich-text_disclosure .block__body{line-height:22px}.disclosures--mobile{padding:0 30px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
